module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l1A93"))).then(() => parcelRequire('1iHdE'));